// extracted by mini-css-extract-plugin
export default {"title":"seoKeywords_title__ZFtgw","icon":"seoKeywords_icon__XgzCD","fieldWrapper":"seoKeywords_fieldWrapper__acCdH","inputField":"seoKeywords_inputField__K1H0C"};